import { useState } from 'react';
import { Pagination, RepayDates } from 'components'; 
import { dateToHumanFormat, numberFormatter } from 'components/misc/constants';

function PaymentDetails({ loan }) {

    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const arrOfTransactions = loan?.transactions?.filter(l => l?.type !== "disburse");
    const currentRecords = arrOfTransactions.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(arrOfTransactions?.length / recordsPerPage);

    return (
        <div>
            <section className="mb-10">
                <div className="mb-3">
                    <h3 className="text-base font-semibold text-gray-900 dark:text-white/[.9]">Repayment dates</h3>
                    <p className="mt-0.5 text-sm text-gray-500 dark:text-white/[.5]">Shows the dates on which payments are to be made.</p>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 gap-2">
                    {loan?.standingOrderDates && loan?.standingOrderDates.length > 0 ? (
                        <RepayDates dates={loan?.standingOrderDates} />
                    ) : (
                        <RepayDates dates={loan?.paymentDates} />
                    )}
                </div>
            </section>


            <section className="mb-10">
                <div className="mb-3">
                    <h3 className="text-base font-semibold text-gray-900 dark:text-white/[.9]">Payment transactions</h3>
                    <p className="mt-0.5 text-sm text-gray-500 dark:text-white/[.5]">Details on the loan repayment transactions.</p>
                </div>

                <div className="overflow-x-auto">
                    <div className="inline-block min-w-full rounded-lg overflow-hidden border border-gray-200 dark:border-white/[.1]">
                        <table className='min-w-full'>
                            <thead className='text-xs font-medium text-left text-gray-500 dark:text-white/[.5] uppercase tracking-wider border-b border-gray-200 dark:border-white/[.1]'>
                                <tr>
                                    <th scope="col" className='px-4 py-3'>Transaction ID</th>
                                    <th scope="col" className='px-4 py-3'>Payment date</th>
                                    <th scope="col" className='px-4 py-3'>Amount (GHS)</th>
                                </tr>
                            </thead>

                            <tbody className="divide-y divide-gray-100 dark:divide-white/[.08]">
                                {currentRecords && currentRecords?.length > 0 ? (
                                    currentRecords?.map(item => (
                                        <tr key={item?.transactionId} className="text-sm text-gray-700 dark:text-white/[.7]">
                                            <td className='px-4 py-3'>{item?.transactionId}</td>
                                            <td className='px-4 py-3'>{dateToHumanFormat(item?.createdAtms)}</td>
                                            <td className='px-4 py-3'>GHS {numberFormatter(item?.amount)}</td>
                                        </tr>
                                    ))
                                ) : (
                                <tr className="text-sm text-gray-500 dark:text-white/[.5]">
                                    <td colSpan="6" className='px-4 py-8 text-center'>
                                        No payments made yet.
                                    </td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                        {(currentRecords && currentRecords?.length > 0) && 
                            <Pagination 
                                nPages={nPages}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                length={arrOfTransactions?.length}
                            />
                        }
                    </div>
                </div>
            </section>


        </div>
    )
}

export default PaymentDetails